import React from 'react';
import { Button, Popover, Divider } from 'antd';
import { mdiMapMarkerPath, mdiAccountSearch, mdiFlash, mdiDotsHorizontal } from '@mdi/js';
import Icon from '@mdi/react';
import useQueryParams from 'hooks/useQueryParams';
import Ninja from '@ninja';

const JourneyIdsFormatter = ({ row }) => {
  const { setUrlParams, searchParams } = useQueryParams();
  const { event_id = false, session_id = false, user_id = false } = searchParams;

  if (row.session_id == null && row.user_id == null && row.event_id == null) return '-';

  const items = [
    row.session_id != null && {
      key: 'session',
      label: 'Session',
      value: row.session_id,
      icon: mdiMapMarkerPath,
      color: Ninja.colors.info,
      onClick: () => setUrlParams({ report: 'user_journey', session_id: row.session_id }),
    },
    row.user_id != null && {
      key: 'user',
      label: 'User',
      value: row.user_id,
      icon: mdiAccountSearch,
      color: Ninja.colors.darkText,
      onClick: () => setUrlParams({ report: 'user_journey', user_id: row.user_id }),
    },
    row.event_id != null && {
      key: 'event',
      label: 'Event',
      value: row.event_id,
      icon: mdiFlash,
      color: Ninja.colors.mediumBlue,
      onClick: () => setUrlParams({ report: 'user_journey', event_id: row.event_id }),
    },
  ].filter(Boolean);

  const toNum = (v) => (typeof v === 'string' ? Number(v) : v);

  return (
    <Popover
      placement='rightTop'
      trigger='click'
      overlayInnerStyle={{ padding: 3 }}
      content={
        <div className='grid'>
          {items.map((item, index) => (
            <div key={item.key}>
              <div
                className='flex items-center gap-3 rounded-sm px-2 py-1 cursor-pointer transition duration-500 hover:bg-background-light'
                onClick={item.onClick}
              >
                <Icon path={item.icon} size={0.85} color={item.color} />
                <div>
                  <div className='text-xs font-normal text-gray'>{item.label}</div>
                  <div className='text-sm font-medium' style={{ color: item.color }}>
                    {item.value}
                  </div>
                </div>
              </div>
              {index < items.length - 1 && <Divider />}
            </div>
          ))}
        </div>
      }
    >
      <Button
        type={
          toNum(session_id) === toNum(row?.session_id) ||
          toNum(user_id) === toNum(row?.user_id) ||
          toNum(event_id) === toNum(row?.event_id)
            ? 'primary'
            : 'text'
        }
        size='small'
        shape='circle'
        icon={<Icon path={mdiDotsHorizontal} size={0.85} />}
      />
    </Popover>
  );
};

export default JourneyIdsFormatter;
